var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97168 10.4224C6.94287 10.4224 7.85693 10.1431 8.63135 9.66064L11.2466 12.2759C11.4561 12.4854 11.7417 12.5869 12.0337 12.5869C12.6494 12.5869 13.1128 12.1108 13.1128 11.4951C13.1128 11.2158 13.0176 10.9365 12.8018 10.7271L10.2119 8.13086C10.7451 7.32471 11.0498 6.36621 11.0498 5.33789C11.0498 2.54492 8.76465 0.253418 5.97168 0.253418C3.17871 0.253418 0.887207 2.53857 0.887207 5.33789C0.887207 8.13086 3.17871 10.4224 5.97168 10.4224ZM5.97168 8.87354C4.02295 8.87354 2.42969 7.28027 2.42969 5.33789C2.42969 3.39551 4.02295 1.80225 5.97168 1.80225C7.91406 1.80225 9.50732 3.39551 9.50732 5.33789C9.50732 7.28027 7.91406 8.87354 5.97168 8.87354Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.50725fbb.svg";
export { ForwardRef as ReactComponent };